import React, { useState, useEffect } from 'react';
import './LayerBox.css';

export default function LayerBox({ viewerRef, layerSources, formattedLayers, loadProject, layerProgress }) {
  const [allData, setAllData] = useState([]);
  const [layerVisibility, setLayerVisibility] = useState({
    'WD_brisbane_5m_400mm_48h': true,
    'WD_brisbane_5m_700mm_48h': true,
    'WD_brisbane_30m_300m_48h': true,
    'WD_west_brisbane_5m_700mm_48h': true,
    'WD_goldcoast_5m_500mm_48h': true,
    'WD_lismore_5m_450mm_24h': true,
    'WD_Europe': true,
  });

  useEffect(() => {
    if (formattedLayers) {
      console.log("Updated layers prop in LayerBox:", formattedLayers);
      setAllData(formattedLayers);
    }
  }, [formattedLayers]);

  // Group the data by city-date
  const grouped = groupByCityAndDate(allData);
  const tableGroups = Object.values(grouped);

  const toggleCheck = (row) => {
    const updated = [...allData];
    const index = updated.indexOf(row);
    if (index !== -1) {
      updated[index] = { ...updated[index], checked: !updated[index].checked };
      setAllData(updated);
    }
  };

  if (allData.length === 0) {
    return <div className="tables-container">No data available to display.</div>;
  }

  const toggleLayerVisibility = (layerName) => {
    const viewer = viewerRef.current.cesiumElement;
    const newVisibility = !layerVisibility[layerName];

    if (layerSources[layerName]) {
      layerSources[layerName].forEach(dataSource => {
        if (newVisibility) {
          viewer.dataSources.add(dataSource);
        } else {
          viewer.dataSources.remove(dataSource);
        }
      });
    }

    setLayerVisibility(prev => ({
      ...prev,
      [layerName]: newVisibility
    }));
  };

  return (
    <div className="tables-container">
      <div className="layer-control-header">
        <h3>Brisbane 06/03/2025</h3>
        {layerProgress === 0 ? (
          <button onClick={loadProject} style={{ height: '24px', width: "100px", marginLeft: 'auto', marginRight: 'auto', display: "block", border: "1px solid #097d46" }}>Load Project</button>
        ) : layerProgress < 100 ? (
          <div className="progress-bar">
            <div className="progress" style={{ width: `${layerProgress}%` }}></div>
          </div>
        ) : (
          <span className="progress-complete">Project Ready</span>
        )}
      </div>
      {/* <ul className="layer-list">
        {Object.keys(layerVisibility).map(layerName => (
          <li key={layerName}>
            <input
              type="checkbox"
              id={layerName}
              checked={layerVisibility[layerName]}
              onChange={() => toggleLayerVisibility(layerName)}
              disabled={layerProgress < 100}
            />
            <label htmlFor={layerName}>{layerName}</label>
          </li>
        ))}
      </ul> */}
      {/* New Table Design */}
      {tableGroups.map((group, i) => (
        <div className="table-container" key={i}>
          <h3>
            {group.city} – {group.date}
          </h3>
          <div className="table">
            <div className="table-header">
              <span>Depth</span>
              <span>Rainfall</span>
              <span>Time</span>
            </div>
            {group.rows.map((row, j) => (
              <div className="table-row" key={j}>
                <label className="checkbox-container">
                  <input
                    type="checkbox"
                    checked={row.checked}
                    onChange={() => toggleCheck(row)}
                  />
                </label>
                <span>{row.depth}</span>
                <span>{row.rainfall}</span>
                <span>{row.time}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function groupByCityAndDate(data) {
  return data.reduce((acc, item) => {
    const key = `${item.city} - ${item.date}`;
    if (!acc[key]) {
      acc[key] = { city: item.city, date: item.date, rows: [] };
    }
    acc[key].rows.push(item);
    return acc;
  }, {});
}
